import { Tooltip } from 'antd';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FileSalesStatusEnum } from '../../enums/FileSalesStatusEnum';
import { FilesTableEnum } from '../../enums/FilesTableEnum';
import { useAuth } from '../../hooks/useAuth';
import File from '../../interfaces/File';
import {
  getFileTitle,
  getFolderHex,
  removeShortcutExtension,
} from '../../utils/utils';
import FileIcon from '../Common/FileIcon';
import TruncatedTooltip from '../Common/TruncatedTooltip';
import { Icon } from '../Core/Icon';

interface FilesTableTitleCellProps {
  file: File;
}

const FilesTableTitleCell: React.FC<FilesTableTitleCellProps> = ({ file }) => {
  const { isInFileRoute } = useAuth();
  const { t } = useTranslation();

  return (
    <div className="flex cursor-pointer flex-row items-center gap-2 hover:underline">
      <Tooltip title={file.title} placement="top">
        <FileIcon
          isShortcut={file.isShortcut}
          isFolder={file.isFolder}
          fileExtension={removeShortcutExtension(file.fileExtension)}
          className="h-8 w-8"
          style={{
            color: getFolderHex(file),
          }}
        />
      </Tooltip>
      <div
        className={clsx(
          'filename-click-handler truncatemin-h-[16px] block max-w-[400px]',
          file.isUnRead && 'font-bold'
        )}
      >
        <TruncatedTooltip className="min-h-[16px]">
          {removeShortcutExtension(getFileTitle(file))}
        </TruncatedTooltip>
      </div>
      {file.isFavourite && (
        <Tooltip title="Favourite">
          <div>
            <Icon name="StarFullIcon" className="h-5 w-5 text-blue-dark" />
          </div>
        </Tooltip>
      )}
      {file.isShared && (
        <Tooltip title="Shared">
          <div>
            <Icon name="FileUserIcon" className="h-5 w-5 text-blue-dark" />
          </div>
        </Tooltip>
      )}
      {file.salesStatus === FileSalesStatusEnum.ForSale && (
        <Tooltip title="For Sale">
          <div>
            <Icon name="StoreIcon" className="h-5 w-5 text-blue-dark" />
          </div>
        </Tooltip>
      )}

      {isInFileRoute(FilesTableEnum.Received) && (
        <Tooltip
          title={file.readOnly ? t('common.viewer') : t('common.editor')}
        >
          <div>
            {file.readOnly ? (
              <Icon name="ViewIcon" className="h-5 w-5 text-yellow-dark" />
            ) : (
              <Icon name="SquarePenIcon" className="h-5 w-5 text-green-dark" />
            )}
          </div>
        </Tooltip>
      )}
    </div>
  );
};

export default FilesTableTitleCell;
